<template>
    <div class="spotlight-result-item" :class="{ 'spotlight-result-item--focused': focused }" @click="$emit('select', item)">
        <div class="spotlight-result-icon spotlight-result-icon--note">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
        </div>
        <div class="spotlight-result-text">
            <div class="spotlight-result-title">
                <span v-if="item.meta && item.meta.color" class="spotlight-result-dot" :style="{ background: item.meta.color }"></span>
                <span class="spotlight-result-title-text">{{ item.title }}</span>
            </div>
            <div v-if="item.subtitle" class="spotlight-result-subtitle">{{ item.subtitle }}</div>
        </div>
        <div v-if="sharedBy" class="spotlight-result-meta">
            <span class="spotlight-shared-by">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                {{ sharedBy }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoteResult',
    props: { item: Object, focused: Boolean },
    emits: ['select'],
    computed: {
        sharedBy() {
            return this.item.meta?.shared_by?.name || null
        }
    }
}
</script>
